module.exports = __webpack_public_path__ + "static/img/fzkLogo.88736aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/fzkLogo.png
// module id = Rmof
// module chunks = 55